module.exports = __webpack_public_path__ + "static/media/login.77715adb.png";